<section class="container">
	<div class="container__content">
		<app-nadpis [klicTextu]="'domu.nadpis'"></app-nadpis>

		<p>{{ 'domu.text.cast1' | lokalizace }}{{ urlAplikace }}{{ 'domu.text.cast2' | lokalizace }}</p>
	</div>
</section>
